import { fetchSellerForPanelAction } from 'redux/actions/sellersActions';
import { generateRequestWithDataReducer } from 'redux/utils/requestWithData';

export default generateRequestWithDataReducer(fetchSellerForPanelAction);
